// extracted by mini-css-extract-plugin
var _1 = "ClosedNonParticipant_container__WE2nJ";
var _2 = "ClosedNonParticipant_faHandHoldingBox__eGOqq fontawesome_min_fa-hand-holding-box__viBog";
var _3 = "ClosedNonParticipant_fal__Cdh5Q fa-light_min_fal__ABekM fontawesome_min_fal__-+-vD";
var _4 = "ClosedNonParticipant_header__uCmYc";
var _5 = "ClosedNonParticipant_icon__tqx02 fontawesome_min_fa-hand-holding-box__viBog";
var _6 = "ClosedNonParticipant_info__GqZDo";
var _7 = "ClosedNonParticipant_mobile__KjbS2";
export { _1 as "container", _2 as "faHandHoldingBox", _3 as "fal", _4 as "header", _5 as "icon", _6 as "info", _7 as "mobile" }
